<template lang="pug">
.changelog
  router-link(:to="{name: routeName, params: { changelogSlug: changelog.slug } }") 
    .changelog-title
      .row.center.apart
        .col
          h3 {{ changelog.title }}
        .col.statuss
          span {{ changelog.status.label }}
    .changelog-description(v-html="changelog.description")
    //-footer
      div {{ changelog.created | moment("MMMM Do YYYY") }}
      UserAvatar(:user="changelog.creator")
</template>

<script>

export default {
  name: 'Changelog',
  components: {
  },
  props: {
    changelog: Object
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  computed: {
    routeName () {
      return this.$route.matched[0].meta.member ? 'AdminChangelogDetail' : 'PublicChangelogDetail'
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="stylus">
.changelog
  padding $spacing 0
  margin-bottom $spacing-5
.changelog-title
  margin-bottom 15px
  h3
    font-size 22px
    line-height 26px
    +for_breakpoint(mobile)
      font-size 18px
  .status
    font-size 12px
.changelog-description
  margin-bottom $spacing-2

</style>
